//import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
//import Button from '@material-ui/core/Button';
//import IconButton from '@material-ui/core/Button';
//import DeleteIcon from '@material-ui/icons/Delete';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
//import FormHelperText from '@material-ui/core/FormHelperText';

export class ProductSelect extends Component {

	render() {
		const {productType, name, label, onChange, disabled} = this.props;

		const products = [
			{type: 'etoh', display: 'Ethanol'},
			//{type: 'unleaded', display: 'Unleaded'},
		];

		const id = `ps_${name}`;
		return (<Grid spacing={2} container>
			<Grid item xs={12} md={6}>
				<FormControl fullWidth={true} disabled={disabled}>
					<InputLabel htmlFor={id}>{label}</InputLabel>
					<Select
						value={productType}
						onChange={(e) => onChange(e, name)}
						input={<Input name={id} id={id}/>}
					>
						{products.map(item => {
							return (<MenuItem key={item.type} value={item.type}>
								{item.display}
							</MenuItem>);
						})}
					</Select>
				</FormControl>
			</Grid>
		</Grid>);
	}
}

ProductSelect.propTypes = {
	disabled : PropTypes.bool,
	productType : PropTypes.string,
	name : PropTypes.string.isRequired,
	label : PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
};
